import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch, InjectReactive } from "vue-property-decorator";
import { choice } from "@modules/newCommunity/pages/operationTools/pages/questionnaireEdit/validateUtils/newIndex";
import draggable from "vuedraggable";
import questionSettingTemplate from "./questionSettingTemplate.vue";
import PicUpload from "@/components/picUpload/index.vue";
import EditSortDialog from "@/modules/newCommunity/pages/operationTools/pages/questionnaire/components/EditSortDialog.vue";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
import { getCatalog, EnumCommunityType } from "@modules/newCommunity/pages/operationTools/api/questionnaire";
import { randomNumber } from "@/utils/commonUtil";
let SingleChoice = class SingleChoice extends Vue {
  constructor() {
    super(...arguments);
    this.editSortDialogKey = Math.random();
    this.drag = false;
    this.loading = false;
    this.catalogList = [];
    this.postForm = {
      title: "请选择以下选项",
      itemScore: 0,
      required: "1",
      optionContentType: "TEXT",
      optionsList: [{
        value: "选项1",
        content: "选项1",
        rightOption: true,
        otherInput: false,
        jsonConfig: {
          openPoint: false,
          pointValue: undefined
        },
        id: 0
      }, {
        value: "选项2",
        content: "选项2",
        rightOption: false,
        otherInput: false,
        jsonConfig: {
          openPoint: false,
          pointValue: undefined
        },
        id: 1
      }],
      catalogIds: [],
      whetherJoinQuestionBank: false,
      scoreRule: "",
      jsonConfig: {
        scoreRule: "SAME",
        openPoint: false,
        showIndex: true,
        otherInputForm: "NONE",
        otherInputNumberMin: null,
        otherInputNumberMax: null,
        otherInputNumberPrecision: null,
        otherInputMin: null,
        otherInputMax: null,
        selectRangeMin: null,
        selectRangeMax: null,
        otherInputUnitType: "NONE",
        unitFirst: "",
        unitSecond: "",
        secondOtherInputForm: "NONE",
        secondOtherInputNumberMin: null,
        secondOtherInputNumberMax: null,
        secondOtherInputNumberPrecision: null,
        secondOtherInputMin: null,
        secondOtherInputMax: null
      }
    };
    this.optionValidator = choice.content;
    this.rules = {
      title: [{
        required: true,
        message: "请输入标题",
        type: "string",
        trigger: "blur"
      }],
      required: [{
        required: true,
        message: "请选择是否必填",
        trigger: "blur"
      }],
      itemScore: [{
        required: true,
        message: "请填写题目分值",
        trigger: "blur"
      }],
      scoreRule: [{
        trigger: "blur",
        validator: this.validatorScoreRule
      }],
      optionsList: [{
        required: true,
        type: "array",
        validator: choice.optionsList
      }],
      // catalogIds: [{ required: true, type: "array", message: "请选择分类名", trigger: "blur" }],
      whetherJoinQuestionBank: [{
        required: true,
        message: "请选择是否加入题库",
        trigger: "blur"
      }],
      "jsonConfig.otherInputForm": [{
        required: true,
        message: "请选择",
        trigger: "blur"
      }],
      "jsonConfig.otherInputUnitType": [{
        required: true,
        message: "请选择",
        trigger: "blur"
      }]
    };
  }
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      var _params$jsonConfig;
      // this.postForm = JSON.parse(JSON.stringify(this.value));
      const params = JSON.parse(JSON.stringify(this.value));
      // 处理历史数据
      if (!((_params$jsonConfig = params.jsonConfig) !== null && _params$jsonConfig !== void 0 && _params$jsonConfig.otherInputUnitType)) {
        params.jsonConfig.otherInputUnitType = "NONE";
        params.jsonConfig.unitFirst = "";
        params.jsonConfig.unitSecond = ""; // 第二单位
        params.jsonConfig.secondOtherInputForm = "NONE"; // 第二单位 填写格式
        params.jsonConfig.secondOtherInputNumberMin = undefined; // 第二单位 数值类型 最小数值
        params.jsonConfig.secondOtherInputNumberMax = undefined; // 第二单位 数值类型 最大数值
        params.jsonConfig.secondOtherInputNumberPrecision = 0; // 第二单位 数值类型 小数点
        params.jsonConfig.secondOtherInputMin = undefined; // 第二单位 其他类型 最小字数
        params.jsonConfig.secondOtherInputMax = undefined; // 第二单位 其他类型 最大字数
      }
      this.postForm = JSON.parse(JSON.stringify(params));
      this.clearValidate();
      this.$nextTick(() => {
        this.validate();
      });
    }
  }
  get settingsList() {
    if (this.postForm.jsonConfig.otherInputUnitType === "UNIT") return 2;
    return 1;
  }
  validatorScoreRule(rule, value, callback) {
    if (this.postForm.scoreRule == "SAME") {
      if (this.postForm.optionsList.filter(op => {
        return op.rightOption;
      }).length == 0) {
        return callback(new Error("请至少选择一个正确答案"));
      }
    }
    callback();
  }
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    console.warn("postForm", this.postForm);
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  optionContentTypeChange() {
    this.postForm.optionsList.forEach(item => {
      item.content = "";
      item.otherInput = false;
    });
  }
  clearOption(clickindex) {
    for (const index in this.postForm.optionsList) {
      if (index != clickindex) {
        this.postForm.optionsList[index].rightOption = false;
      }
    }
    this.itemScoreCount();
  }
  emitChange() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  removeOption(item, index) {
    this.postForm.optionsList.splice(index, 1);
    this.emitChange();
  }
  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }
  get communityType() {
    return this.$route.path.includes("newCommunity") ? EnumCommunityType.DOCTOR : EnumCommunityType.PATIENT;
  }
  get basicParams() {
    return {
      businessType: this.questionnaireType,
      communityType: this.communityType
    };
  }
  get haveOtherSet() {
    return this.postForm.optionsList.some(ot => {
      return ot.otherInput;
    });
  }
  addOption(otherInput) {
    const str = this.postForm.optionContentType == "TEXT" ? "选项" + (this.postForm.optionsList.length + 1) : "";
    this.postForm.optionsList.push({
      value: str,
      content: otherInput ? "其它" : str,
      rightOption: false,
      otherInput: otherInput,
      jsonConfig: {
        openPoint: false,
        pointValue: undefined
      },
      id: Number("1" + (randomNumber(6) + "")) * -1
    });
    this.emitChange();
  }
  getFormInstance() {
    return this.$refs.postForm;
  }
  validateOptions() {
    this.getFormInstance().validateField("optionsList");
  }
  resetFields() {
    this.getFormInstance().resetFields();
  }
  remoteMethod(query) {
    this.loading = true;
    getCatalog({
      ...this.basicParams,
      name: query,
      pageSize: 50,
      pageNum: 1
    }).then(res => {
      this.catalogList = res.rows || [];
    }).finally(() => this.loading = false);
  }
  catalogFocus() {
    if (this.catalogList.length === 0) {
      this.remoteMethod();
    }
  }
  openSortDialog() {
    this.$refs.editSortDialog.onShow({
      isBusinessTypeDisable: true,
      formData: {
        businessType: this.questionnaireType
      }
    });
  }
  itemScoreCount() {
    if (this.postForm.scoreRule == "UPLOAD") {
      let max = 0;
      this.postForm.optionsList.forEach(op => {
        if (op.jsonConfig.itemScore) {
          if (op.jsonConfig.itemScore > max) {
            max = op.jsonConfig.itemScore;
          }
        }
      });
      this.postForm.itemScore = max;
    }
  }
  async validate() {
    let result = await this.getFormInstance().validate().catch(err => {
      return err;
    });
    if (result) {
      this.itemScoreCount();
    }
    return result;
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
  // $ 开始拖拽
  onStart() {
    this.drag = true;
  }
  // $ 结束拖拽
  onEnd() {
    this.drag = false;
    this.emitChange();
  }
};
__decorate([InjectReactive()], SingleChoice.prototype, "templateMode", void 0);
__decorate([Prop({
  type: Object,
  default() {
    return {};
  }
})], SingleChoice.prototype, "value", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], SingleChoice.prototype, "disabled", void 0);
__decorate([Watch("value", {
  deep: true,
  immediate: true
})], SingleChoice.prototype, "watchPropData", null);
__decorate([Watch("postForm", {
  deep: true
})], SingleChoice.prototype, "watchPostForm", null);
SingleChoice = __decorate([Component({
  name: "singleChoice",
  components: {
    PicUpload,
    questionSettingTemplate,
    draggable,
    EditSortDialog
  }
})], SingleChoice);
export default SingleChoice;